<template>
  <v-container>
    <eagle-form :form-key="formKey"></eagle-form>
  </v-container>
</template>

<script lang="babel" type="text/babel">
import formMixin from '@/components/form/mixins/formMixin'
import formConfig from './providerRegister'
import providerApplyStatus from "@/modules/provider/config/providerApplyStatus.ts"
export default {
  mixins: [formMixin],
  data: () => ({
    formKey: 'provider-register-form',
    meta: {},
    isRegistered: false,
  }),
  computed: {
    siteName() {
      return this.$store.getters['base/siteName']
    },
    providerId() {
      return this.$store.getters['member/providerId']
    },
    forceCreate() {
      return this.$route.query.forceCreate
    },
  },
  methods: {
    async beforeFormInit() {
      await Promise.all([])
    },
    validateBeforeSave() {
      // TODO
    },
    afterSaveSuccessCallback(result) {
      this.$helper.closeLiff(1)
    },
    async readApi() {
      const defaultData = {
        name: null,
        member_name: null,
        member_phone: null,
        email: null,
        city: null,
        district:null,
        address:null
      }
      try {
        if(!this.providerId || this.forceCreate) {
          return defaultData
        }
        const res = await this.$api.collection.providerApi.read(this.providerId)
        this.$snotify.error(
          null,
          this.$t('provider.error.register')
        )
        this.isRegistered = true
        this.$store.dispatch('base/setLayoutProvider', res)
        return res
      } catch (err) {
        console.error(err)
        return defaultData
      }
    },
    afterSaveFailCallback(status, errorJson) {
      if (status != 409) return null
      const provider = errorJson.provider
      if (!provider) return null
      if (provider.status === 'request') {
        return '此供應商正在驗證中，請聯絡徠能官方 LINE 帳號以掌握驗證進度'
      }
      return `${provider.name}已是徠能會員，請聯絡該商家負責人邀請您為共同管理員`
    },
    async updateApi(target, formData) {
      this.$root.gaLogEvent('供應商_點擊_註冊')
      const res =  await this.$api.collection.providerApi.create(formData)
      this.$store.dispatch('base/setLayoutProvider', res)
      if (this.forceCreate) {
        this.$router.replace({name: 'provider-switch-identity'})
      }
      return res
    },
    getFormConfig() {
      return formConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
